import React,{useState} from 'react'
import {useHistory} from 'react-router-dom'




import visa_logo from '../../assets/images/icons/visa-icon.png'
import master_card_logo from '../../assets/images/icons/master-card-icon.png'
import line_icon from '../../assets/images/icons/line-icon.png'
import PaymentModel from '../applicantForms/models/paymentModel'


import mtn_card from '../../assets/images/mtn-card.png'
import airtel_card from '../../assets/images/airtel-card.png'

import DragAndDrop from '../../components/dragAndDrop/file-upload.component'






const PaymentsScreen = ()=>{

    const history = useHistory()
    


    const [showModel, setShowModel] = useState(false)
    const [title, setTitlle] = useState('')


    const [changeView, setChangeView] = useState(true)
    const [payLater, setPayLater] = useState(false)
    const [paymentMethod, setPaymentMethod] = useState('')

    const [newUserInfo, setNewUserInfo] = useState({
        profileImages: []
      });
    
      const updateUploadedFiles = (files) =>
        setNewUserInfo({ ...newUserInfo, profileImages: files });


    const handlePayNow = ()=>{
        setChangeView(false)
      }
    
      const handlePayLater = ()=>{
          setChangeView(false)
          setPayLater(true)
      }
    const togglePaymentModel = (method)=>{
        setPaymentMethod(method)
        setChangeView(true)
        setPayLater(false)
        setShowModel(!showModel)
    }


    return (
        <div className="membership_wrapper">
            <div className="toolbar">
                <div className="toolbar-title">
                    <h2>Membership</h2>
                </div>
            </div>
            <div className="payment-details-container mt-4">
                <span>Amount to pay for <br/>
                <span style={{fontWeight: '900'}}>GRADUATE ENGINEER MEMBESHIP CLASS </span> <br/>
                application fee is</span>
            </div>
            <div className="payment-amount-details-ctn">
                <span className="payment-amount-text">50,000 RWF</span>
            </div>
            <div style={{
                width: '100%',
            }}>
                <img src={line_icon} style={{width: '100%'}}/>
            </div>
            
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems:'center',
                padding: 30
            }}>
                <span className="general-span-text-none-auto" style={{fontSize: 30}}>Choose Payment Methods to use</span>
            </div>



    <div className="payments-card-container">
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer'}}
                onClick={()=>{togglePaymentModel('MTN'); setTitlle('Payment via Mobile Money')}}>
                <span className="general-span-text-none-auto">MTN</span>
                <div className="item">
                    <img alt="mtn" src={mtn_card}/>
                </div>
            </div>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center',cursor: 'pointer'}}
                onClick={()=>{togglePaymentModel('AIRTEL'); setTitlle('Payment via AIRTEL Money')}}>
                <span className="general-span-text-none-auto">AIRTEL</span>
                <div className="item">
                    <img alt="airtel" src={airtel_card}/>
                </div>
            </div>
            <div className="item-visa-master-card"
                onClick={()=>{togglePaymentModel('VISA'); setTitlle('Payment Via Card')}}>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <span className="general-span-text-none-auto">BANKS</span>
                    <div className="visa-master-card">
                        <div className="image-ctn d-flex">
                            <div className="d-flex visa-mastercard-ctn">
                                <img src={visa_logo}/>
                            </div>
                            <div className="d-flex visa-mastercard-ctn">
                                <img src={master_card_logo}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <DragAndDrop
                accept=".jpg,.png,.jpeg"
                label="Upload proof of payment,
                paid for Bill ID: 123456"
                multiple
                updateFilesCb={updateUploadedFiles}
            />
        </div>

    <PaymentModel
        title={title}
        show={showModel} 
        hide={togglePaymentModel}
        changeView={changeView}
        setChangeView={setChangeView}
        payLater={payLater}
        setPayLater={setPayLater}
        handlePayNow={handlePayNow}
        handlePayLater={handlePayLater}
        paymentMethod={paymentMethod}
        />
    </div>
    )
}

export default PaymentsScreen
